var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2294 5.20491L19.2239 5.19945L17.3544 3.36038C17.0622 3.06827 16.6662 2.90378 16.253 2.9029C15.8398 2.90202 15.4431 3.06482 15.1497 3.3557L8.11842 10.2791L5.46764 7.72835C5.17388 7.43861 4.77745 7.27681 4.36485 7.27828C3.95225 7.27974 3.55698 7.44434 3.26529 7.73616L1.39029 9.61116C1.09785 9.90411 0.933594 10.3011 0.933594 10.7151C0.933594 11.129 1.09785 11.526 1.39029 11.819L6.9856 17.444C7.1307 17.5891 7.30298 17.7043 7.49259 17.7828C7.68221 17.8614 7.88544 17.9018 8.09068 17.9018C8.29593 17.9018 8.49916 17.8614 8.68877 17.7828C8.87838 17.7043 9.05066 17.5891 9.19576 17.444L19.2294 7.41429C19.5223 7.12128 19.6868 6.72392 19.6868 6.3096C19.6868 5.89528 19.5223 5.49793 19.2294 5.20491ZM8.09342 15.8979L2.93951 10.7159L4.37779 9.27835L7.03014 11.8284C7.32262 12.1175 7.71731 12.2796 8.12857 12.2796C8.53984 12.2796 8.93452 12.1175 9.22701 11.8284L16.2489 4.90413L17.6801 6.31038L8.09342 15.8979Z",
    fill: "#76BB40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyIcon);
export default __webpack_public_path__ + "static/media/ReadyIcon.3b6e09a8.svg";
export { ForwardRef as ReactComponent };